import jsPDF from "jspdf";

export default function gerarEtiquetaPdf(item) {
  const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });

  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();

  const cardW = 380;
  const cardH = 220;

  const pageMargin = 40;
  const cardX = pageMargin;
  const cardY = pageMargin;

  doc.setLineWidth(1);
  doc.rect(cardX, cardY, cardW, cardH);

  const innerPad   = 18;
  const lineHeight = 20;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(14);

  const linhasFixas = [
    `ID: ${item.id}`,
    `LOGIN: ${item.login}`,
    `NOME: ${item.nome}`,
  ];

  const descLines = doc.splitTextToSize(
    `DESCRIÇÃO DO BEM: ${item.descricao}`,
    cardW - innerPad * 2
  );

  const todasLinhas = [...linhasFixas, ...descLines];

  const conteudoAltura = todasLinhas.length * lineHeight;
  let cursorY = cardY + (cardH - conteudoAltura) / 2 + lineHeight;

  todasLinhas.forEach(t => {
    doc.text(t, cardX + innerPad, cursorY);
    cursorY += lineHeight;
  });

  doc.save(`etiqueta-${item.id}.pdf`);
}
